import { Box, Grid, styled, Typography } from '@mui/material';

import theme, { colors } from '../../../theme';

interface AttachmentsContainerProps {
    withPadding?: boolean;
    withMargin?: boolean;
}

export const AttachmentsContainer = styled(Box)<AttachmentsContainerProps>(({ withPadding, withMargin }) => ({
    marginTop: !withMargin ? 0 : theme.spacing(1),
    marginBottom: !withMargin ? 0 : theme.spacing(1),
    padding: !withPadding ? 0 : theme.spacing(1)
}));

export const AttachmentsHeader = styled(Typography)({
    fontSize: '14px',
    color: colors.white50,
    marginBottom: theme.spacing(1)
});

export const AttachmentsGrid = styled(Grid)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto'
});

export const AttachmentItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    backgroundColor: colors.codGray,
    borderRadius: '12px',
    fontSize: '12px',
    gap: '6px',
    color: colors.mainGold,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#3D3F4A'
    }
});

